import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Heading,
  VStack,
  Button,
  useBreakpointValue,
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  useToast,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  SimpleGrid,
  Icon,
  IconButton,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Checkbox,
  FormErrorMessage,
  FormHelperText,
  Badge,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Portal,
  Select,
  InputGroup,
  InputLeftElement,
  Stack,
  Tooltip,
} from "@chakra-ui/react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import DataTable from "react-data-table-component";
import QRCode from "react-qr-code";
import Navbar from "../components/Navbar";
import TemplatesLibrary from "../components/TemplatesLibrary";
import {
  FaUsers,
  FaStore,
  FaHandshake,
  FaDollarSign,
  FaPlus,
  FaTrash,
  FaEdit,
  FaLink,
  FaPaperPlane,
  FaEllipsisV,
  FaTicketAlt,
  FaSearch,
  FaDownload,
  FaEnvelope,
  FaQrcode,
  FaCopy,
  FaCheck,
  FaUserPlus,
} from "react-icons/fa";
import { UserAuth } from "../contexts/AuthContext";
import axios from "axios";
import { apiUrl } from "../config";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ArrowBackIcon } from "@chakra-ui/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TeamMemberDashboard from "./TeamMemberDashboard";
import CampaignReporting from "./CampaignReporting";

// Toolbar limited to the formatting team-instruction authors actually need.
const TEAM_INSTRUCTIONS_QUILL_MODULES = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};
const TEAM_INSTRUCTIONS_QUILL_FORMATS = [
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
];
// Quill emits "<p><br></p>" for an empty editor — treat that as empty.
const isQuillEmpty = (html) =>
  !html || html === "<p><br></p>" || html.replace(/<[^>]+>/g, "").trim() === "";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  isAdmin: Yup.boolean(),
});

const CampaignHome = ({ campaignId: campaignIdProp, embedded = false } = {}) => {
  const params = useParams();
  const campaignId = campaignIdProp ?? params.campaignId;
  const navigate = useNavigate();
  const { user } = UserAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  // Team member = a campaign agent whose isAdmin flag is false. Other viewers
  // (org admins, platform admins, campaign admins) get the full admin UI.
  const [isTeamMember, setIsTeamMember] = useState(false);
  const [roleChecked, setRoleChecked] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [agents, setAgents] = useState([]);
  const [campaignName, setCampaignName] = useState("");
  const [campaignStats, setCampaignStats] = useState({
    agentCount: 0,
    businessCount: 0,
    totalAmountSold: 0,
    totalSalesCount: 0,
  });
  const toast = useToast();

  const buttonSize = useBreakpointValue({ base: "sm", md: "sm" });
  const idToken = sessionStorage.getItem("idToken");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [fundraiserToRemove, setFundraiserToRemove] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [businessToDelete, setBusinessToDelete] = useState(null);
  const [isDeleteBusinessModalOpen, setIsDeleteBusinessModalOpen] =
    useState(false);
  const [organizationId, setOrganizationId] = useState(null);
  const [loadingBusinesses, setLoadingBusinesses] = useState({});
  const [loadingCustomers, setLoadingCustomers] = useState({});
  const [loadingAgents, setLoadingAgents] = useState({});
  const [isCouponsModalOpen, setIsCouponsModalOpen] = useState(false);
  const [selectedSupporter, setSelectedSupporter] = useState(null);
  const [couponStatusFilter, setCouponStatusFilter] = useState("all");
  const [couponSearch, setCouponSearch] = useState("");
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [qrSupporter, setQRSupporter] = useState(null);
  const [isBusinessQRModalOpen, setIsBusinessQRModalOpen] = useState(false);
  const [qrBusiness, setQRBusiness] = useState(null);
  const [isPurchaseQRModalOpen, setIsPurchaseQRModalOpen] = useState(false);
  const [customerSearch, setCustomerSearch] = useState("");
  const [agentSearch, setAgentSearch] = useState("");
  const [businessSearch, setBusinessSearch] = useState("");
  const [redemptionSearch, setRedemptionSearch] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [socialShareTitle, setSocialShareTitle] = useState("");
  const [socialShareBody, setSocialShareBody] = useState("");
  const [isSavingSocialShare, setIsSavingSocialShare] = useState(false);
  const [teamInstructions, setTeamInstructions] = useState("");
  const [isSavingTeamInstructions, setIsSavingTeamInstructions] =
    useState(false);
  const [isTeamUpdateModalOpen, setIsTeamUpdateModalOpen] = useState(false);
  const [teamUpdateNote, setTeamUpdateNote] = useState("");
  const [isSendingTeamUpdate, setIsSendingTeamUpdate] = useState(false);
  // Snapshot of teamInstructions at save time, so editing after save doesn't
  // change what gets emailed.
  const [savedTeamInstructions, setSavedTeamInstructions] = useState("");

  const SOCIAL_TITLE_MAX = 70;
  const SOCIAL_BODY_MAX = 280;
  // Only set the initial tab once, so we don't override a user's manual tab
  // choice if the campaign data finishes loading after they've already clicked.
  const tabIndexInitialized = useRef(false);

  // Resolve viewer's role first so non-admin team members can be redirected
  // to the team-member dashboard without paying for the admin-view data fetch.
  useEffect(() => {
    const checkRole = async () => {
      if (!user?.uid || !campaignId) return;
      try {
        const agentRef = doc(db, `campaigns/${campaignId}/agents`, user.uid);
        const agentDoc = await getDoc(agentRef);
        if (agentDoc.exists()) {
          const data = agentDoc.data();
          setIsAdmin(data.isAdmin === true);
          setIsTeamMember(data.isAdmin !== true);
        } else {
          setIsAdmin(false);
          setIsTeamMember(false);
        }
      } finally {
        setRoleChecked(true);
      }
    };
    checkRole();
  }, [campaignId, user]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      // Skip the admin-view data fetch for team members — they render the
      // dedicated TeamMemberDashboard instead.
      if (roleChecked && isTeamMember) return;

      // Fetch campaign name
      const campaignDoc = await getDoc(doc(db, "campaigns", campaignId));
      if (campaignDoc.exists()) {
        const campaignData = campaignDoc.data();
        setCampaignName(campaignData.name.en);
        setOrganizationId(campaignData.organizationId);
        setSocialShareTitle(campaignData.socialShareTitle || "");
        setSocialShareBody(campaignData.socialShareBody || "");
        setTeamInstructions(campaignData.teamInstructions || "");

        if (!tabIndexInitialized.current) {
          tabIndexInitialized.current = true;
          const startRaw = campaignData.startDate;
          const startDate = startRaw?.toDate
            ? startRaw.toDate()
            : startRaw
            ? new Date(startRaw)
            : null;
          if (startDate && !isNaN(startDate.getTime()) && new Date() >= startDate) {
            setTabIndex(3);
          }
        }
      }

      // Fetch businesses
      const businessesQuery = query(
        collection(db, "businesses"),
        where("campaignId", "==", campaignId),
      );
      const businessesSnapshot = await getDocs(businessesQuery);

      // Get all unique agent IDs from businesses
      const agentIds = [
        ...new Set(businessesSnapshot.docs.map((doc) => doc.data().agentId)),
      ];

      // Fetch agent names
      const agentNames = {};
      for (const agentId of agentIds) {
        if (agentId) {
          // Check if agentId exists
          const agentDoc = await getDoc(
            doc(db, `campaigns/${campaignId}/agents`, agentId),
          );
          if (agentDoc.exists()) {
            const agentData = agentDoc.data();
            agentNames[agentId] = `${agentData.firstName || ""} ${
              agentData.lastName || ""
            }`.trim();
          }
        }
      }

      const businessesData = businessesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        addedBy: agentNames[doc.data().agentId] || "Unknown", // Add the agent name
      }));
      setBusinesses(businessesData);

      // Fetch customers
      const customersQuery = query(
        collection(db, "customers"),
        where("campaignId", "==", campaignId),
      );
      const customersSnapshot = await getDocs(customersQuery);
      setCustomers(
        customersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      );

      // Fetch agents
      const agentsQuery = query(
        collection(db, `campaigns/${campaignId}/agents`),
      );
      const agentsSnapshot = await getDocs(agentsQuery);
      const agentsData = agentsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch pending invites
      const pendingInvitesQuery = query(
        collection(db, "pendingInvites"),
        where("campaignId", "==", campaignId),
        where("type", "==", "campaign"),
        where("status", "==", "pending"),
      );
      const pendingInvitesSnapshot = await getDocs(pendingInvitesQuery);
      const pendingInvitesData = pendingInvitesSnapshot.docs.map((doc) => ({
        id: doc.id,
        email: doc.data().email,
        isAdmin: doc.data().isAdmin,
        status: "pending",
        saleCount: 0,
        saleAmount: 0,
      }));

      // Combine agents and pending invites
      setAgents([...agentsData, ...pendingInvitesData]);

      // Calculate campaign stats (only count actual agents, not pending invites)
      const totalAmountSold = agentsData.reduce(
        (sum, agent) => sum + (agent.saleAmount || 0),
        0,
      );
      const totalSalesCount = agentsData.reduce(
        (sum, agent) => sum + (agent.saleCount || 0),
        0,
      );

      setCampaignStats({
        agentCount: agentsData.length + pendingInvitesData.length, // Include pending invites in count
        businessCount: businessesData.length,
        totalAmountSold,
        totalSalesCount,
      });
    };

    fetchData();
  }, [campaignId, user, roleChecked, isTeamMember]);

  const getBusinessStatus = (business) => {
    if (business.approved) {
      return { label: "Approved", colorScheme: "green" };
    }
    if (business.sentOut) {
      return { label: "Under Review", colorScheme: "purple" };
    }
    if (business.selfCompletion) {
      return { label: "Submission Pending", colorScheme: "yellow" };
    }
    return { label: "Draft", colorScheme: "gray" };
  };

  const agentStatusColumnWidth = useMemo(() => {
    const labels = ["Active", "Pending"];
    const padding = 32;
    if (typeof document === "undefined") {
      const maxLen = Math.max(...labels.map((l) => l.length));
      return `${maxLen * 8 + padding}px`;
    }
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = "500 14px system-ui, -apple-system, sans-serif";
    const widest = Math.max(...labels.map((l) => ctx.measureText(l).width));
    return `${Math.ceil(widest + padding)}px`;
  }, []);

  const businessStatusColumnWidth = useMemo(() => {
    const labels = [
      "Approved",
      "Under Review",
      "Submission Pending",
      "Draft",
    ];
    // Badge horizontal padding (px=3 → 24px) + a little cell breathing room
    const padding = 32;
    if (typeof document === "undefined") {
      const maxLen = Math.max(...labels.map((l) => l.length));
      return `${maxLen * 8 + padding}px`;
    }
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = "500 14px system-ui, -apple-system, sans-serif";
    const widest = Math.max(...labels.map((l) => ctx.measureText(l).width));
    return `${Math.ceil(widest + padding)}px`;
  }, []);

  const businessColumns = [
    {
      name: "Business",
      selector: (row) => row.name?.en || "",
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      name: "Coupon",
      selector: (row) => row.offerTitle?.en || "",
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      name: "Contact Name",
      selector: (row) => row.contactName || "",
      cell: (row) => (
        <HStack spacing={1}>
          <Text fontSize="sm">{row.contactName || ""}</Text>
          {row.ownerUid && (
            <Tooltip
              label="Contact has created an account"
              hasArrow
              fontSize="xs"
            >
              <Box as="span" display="inline-flex" alignItems="center">
                <Icon
                  as={FaCheck}
                  color="green.500"
                  boxSize={3}
                  aria-label="Account created"
                />
              </Box>
            </Tooltip>
          )}
        </HStack>
      ),
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      name: "Created",
      selector: (row) => row.createdAt?.toDate().getTime() || 0,
      cell: (row) => {
        const d = row.createdAt?.toDate();
        if (!d) return "";
        const date = d.toLocaleString(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
        const time = d.toLocaleString(undefined, {
          hour: "numeric",
          minute: "2-digit",
        });
        return (
          <Box lineHeight="short">
            <Text fontSize="sm">{date}</Text>
            <Text fontSize="xs" color="gray.500">
              {time}
            </Text>
          </Box>
        );
      },
      sortable: true,
      width: "130px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = getBusinessStatus(row);
        return (
          <Badge
            colorScheme={status.colorScheme}
            variant="subtle"
            textTransform="none"
            fontWeight="medium"
            borderRadius="full"
            px={3}
            py={0.5}
          >
            {status.label}
          </Badge>
        );
      },
      sortable: true,
      width: businessStatusColumnWidth,
    },
    {
      cell: (row) => {
        const isLoading = !!loadingBusinesses[row.id];
        const canSendForApproval = isAdmin && !row.approved;
        return (
          <HStack spacing={1} justify="flex-end">
            {isAdmin && (
              <IconButton
                icon={<FaEdit />}
                aria-label="Edit business"
                title="Edit"
                size="sm"
                variant="ghost"
                color="gray.500"
                _hover={{ color: "gray.700", bg: "gray.100" }}
                onClick={() =>
                  navigate(`/edit-business?businessId=${row.id}`)
                }
              />
            )}
            <Menu placement="bottom-end">
              <MenuButton
                as={IconButton}
                icon={<FaEllipsisV />}
                variant="ghost"
                size="sm"
                aria-label="More actions"
                color="gray.500"
                _hover={{ color: "gray.700", bg: "gray.100" }}
                _active={{ bg: "gray.100" }}
              />
              <Portal>
                <MenuList shadow="lg" borderRadius="md" py={1} minW="200px">
                  <Tooltip
                    label={row.email || "No email on file"}
                    hasArrow
                    placement="left"
                    isDisabled={!row.email}
                    openDelay={200}
                  >
                    <MenuItem
                      icon={<FaEnvelope />}
                      as={row.email ? "a" : "button"}
                      href={row.email ? `mailto:${row.email}` : undefined}
                      isDisabled={!row.email}
                    >
                      Send email
                    </MenuItem>
                  </Tooltip>
                  <MenuItem
                    icon={<FaQrcode />}
                    onClick={() => openBusinessQR(row)}
                  >
                    Show QR code
                  </MenuItem>
                  {canSendForApproval && (
                    <MenuItem
                      icon={
                        isLoading ? <Spinner size="sm" /> : <FaPaperPlane />
                      }
                      onClick={() => handleSendForApproval(row)}
                      isDisabled={isLoading}
                    >
                      Send for Approval
                    </MenuItem>
                  )}
                  {canSendForApproval && (
                    <MenuItem
                      icon={
                        isLoading ? <Spinner size="sm" /> : <FaPaperPlane />
                      }
                      onClick={() => handleResendInvitation(row)}
                      isDisabled={isLoading}
                    >
                      Resend Invitation
                    </MenuItem>
                  )}
                  {isAdmin && !row.ownerUid && (
                    <MenuItem
                      icon={
                        isLoading ? <Spinner size="sm" /> : <FaUserPlus />
                      }
                      onClick={() => handleSendOwnerClaim(row)}
                      isDisabled={isLoading || !row.email}
                    >
                      Invite Owner to Register
                    </MenuItem>
                  )}
                  {isAdmin && (
                    <>
                      <MenuDivider />
                      <MenuItem
                        icon={<FaTrash />}
                        onClick={() => initiateDeleteBusiness(row)}
                        color="red.500"
                      >
                        Delete
                      </MenuItem>
                    </>
                  )}
                </MenuList>
              </Portal>
            </Menu>
          </HStack>
        );
      },
      width: "80px",
      right: true,
    },
  ];

  const agentNamesById = useMemo(() => {
    const map = {};
    for (const a of agents) {
      const fullName = `${a.firstName || ""} ${a.lastName || ""}`.trim();
      if (a.id && fullName) {
        map[a.id] = fullName;
      }
    }
    return map;
  }, [agents]);

  const getSupporterTeamMember = (row) =>
    (row.agentId && agentNamesById[row.agentId]) || "";

  const filteredCustomers = useMemo(() => {
    const q = customerSearch.trim().toLowerCase();
    if (!q) return customers;
    return customers.filter((c) => {
      const haystack = [
        c.name,
        c.email,
        c.customerCode,
        getSupporterTeamMember(c),
        c.createdAt?.toDate().toLocaleString(),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
    // getSupporterTeamMember depends on agentNamesById, which is in deps below
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customers, customerSearch, agentNamesById]);

  const customerColumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      name: "Purchase",
      selector: (row) => row.createdAt?.toDate().getTime() || 0,
      cell: (row) => {
        const d = row.createdAt?.toDate();
        if (!d) return "";
        const date = d.toLocaleString(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
        const time = d.toLocaleString(undefined, {
          hour: "numeric",
          minute: "2-digit",
        });
        return (
          <Box lineHeight="short">
            <Text fontSize="sm">{date}</Text>
            <Text fontSize="xs" color="gray.500">
              {time}
            </Text>
          </Box>
        );
      },
      sortable: true,
      width: "130px",
    },
    {
      name: "Team Member",
      selector: getSupporterTeamMember,
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      cell: (row) => {
        const isLoading = !!loadingCustomers[row.id];
        return (
          <HStack spacing={1} justify="flex-end">
            <IconButton
              icon={<FaTicketAlt />}
              aria-label="View coupons"
              title="View coupons"
              size="sm"
              variant="ghost"
              color="gray.500"
              _hover={{ color: "gray.700", bg: "gray.100" }}
              onClick={() => openSupporterCoupons(row)}
            />
            <Menu placement="bottom-end">
              <MenuButton
                as={IconButton}
                icon={<FaEllipsisV />}
                variant="ghost"
                size="sm"
                aria-label="More actions"
                color="gray.500"
                _hover={{ color: "gray.700", bg: "gray.100" }}
                _active={{ bg: "gray.100" }}
              />
              <Portal>
                <MenuList shadow="lg" borderRadius="md" py={1} minW="200px">
                  <Tooltip
                    label={row.email || "No email on file"}
                    hasArrow
                    placement="left"
                    isDisabled={!row.email}
                    openDelay={200}
                  >
                    <MenuItem
                      icon={<FaEnvelope />}
                      as={row.email ? "a" : "button"}
                      href={row.email ? `mailto:${row.email}` : undefined}
                      isDisabled={!row.email}
                    >
                      Send email
                    </MenuItem>
                  </Tooltip>
                  {row.customerCode && (
                    <MenuItem
                      icon={<FaQrcode />}
                      onClick={() => openSupporterQR(row)}
                    >
                      Show QR code
                    </MenuItem>
                  )}
                  <MenuItem
                    icon={
                      isLoading ? <Spinner size="sm" /> : <FaPaperPlane />
                    }
                    onClick={() => handleResendEmail(row.id)}
                    isDisabled={isLoading}
                  >
                    Resend purchase email
                  </MenuItem>
                </MenuList>
              </Portal>
            </Menu>
          </HStack>
        );
      },
      width: "80px",
      right: true,
    },
  ];

  const openSupporterCoupons = (supporter) => {
    setSelectedSupporter(supporter);
    setCouponStatusFilter("all");
    setCouponSearch("");
    setIsCouponsModalOpen(true);
  };

  const openSupporterQR = (supporter) => {
    setQRSupporter(supporter);
    setIsQRModalOpen(true);
  };

  const openBusinessQR = (business) => {
    setQRBusiness(business);
    setIsBusinessQRModalOpen(true);
  };

  const getBusinessValidationUrl = (business) =>
    business?.passcode
      ? `${window.location.origin}/validate/${business.passcode}`
      : "";

  const escapeCsvField = (value) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    if (/[",\r\n]/.test(str)) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const handleExportSupportersCSV = () => {
    if (!filteredCustomers.length) {
      toast({
        title: "No supporters to export",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const headers = [
      "Name",
      "Email",
      "Purchase Date",
      "Team Member",
      "Customer Code",
    ];
    const rows = filteredCustomers.map((c) => [
      c.name || "",
      c.email || "",
      c.createdAt?.toDate().toLocaleString() || "",
      getSupporterTeamMember(c),
      c.customerCode || "",
    ]);

    const csv = [
      headers.map(escapeCsvField).join(","),
      ...rows.map((row) => row.map(escapeCsvField).join(",")),
    ].join("\r\n");

    // Prepend UTF-8 BOM so Excel renders accented characters correctly
    const blob = new Blob(["﻿" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const safeName = (campaignName || "campaign").replace(/[^\w-]+/g, "_");
    const dateStr = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = `supporters-${safeName}-${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast({
      title: `Exported ${filteredCustomers.length} supporter${
        filteredCustomers.length === 1 ? "" : "s"
      }`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const redemptionsData = useMemo(() => {
    const counts = new Map();
    for (const customer of customers) {
      const redemptions = customer.redemptions || {};
      for (const businessId of Object.keys(redemptions)) {
        if (!redemptions[businessId]) continue;
        counts.set(businessId, (counts.get(businessId) || 0) + 1);
      }
    }
    return businesses
      .map((b) => ({
        id: b.id,
        businessName: b.name?.en || "",
        offerTitle: b.offerTitle?.en || "",
        redemptions: counts.get(b.id) || 0,
      }))
      .sort((a, b) => b.redemptions - a.redemptions);
  }, [businesses, customers]);

  const filteredRedemptions = useMemo(() => {
    const q = redemptionSearch.trim().toLowerCase();
    if (!q) return redemptionsData;
    return redemptionsData.filter((r) => {
      const haystack = [r.businessName, r.offerTitle]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [redemptionsData, redemptionSearch]);

  const handleExportRedemptionsCSV = () => {
    if (!filteredRedemptions.length) {
      toast({
        title: "No redemptions to export",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const headers = ["Business", "Offer", "Redemptions"];
    const rows = filteredRedemptions.map((r) => [
      r.businessName,
      r.offerTitle,
      r.redemptions,
    ]);

    const csv = [
      headers.map(escapeCsvField).join(","),
      ...rows.map((row) => row.map(escapeCsvField).join(",")),
    ].join("\r\n");

    const blob = new Blob(["﻿" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const safeName = (campaignName || "campaign").replace(/[^\w-]+/g, "_");
    const dateStr = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = `redemptions-${safeName}-${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast({
      title: `Exported ${filteredRedemptions.length} row${
        filteredRedemptions.length === 1 ? "" : "s"
      }`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const redemptionColumns = [
    {
      name: "Business",
      selector: (row) => row.businessName,
      sortable: true,
      grow: 2,
    },
    {
      name: "Offer",
      selector: (row) => row.offerTitle,
      sortable: true,
      grow: 2,
    },
    {
      name: "Redemptions",
      selector: (row) => row.redemptions,
      sortable: true,
      width: "150px",
      right: true,
    },
  ];

  const getAgentDisplayName = (agent) => {
    if (agent.status === "pending") return "Pending Invite";
    return `${agent.firstName || ""} ${agent.lastName || ""}`.trim();
  };

  const filteredBusinesses = useMemo(() => {
    const q = businessSearch.trim().toLowerCase();
    if (!q) return businesses;
    return businesses.filter((b) => {
      const haystack = [
        b.name?.en,
        b.contactName,
        b.email,
        b.addedBy,
        getBusinessStatus(b).label,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [businesses, businessSearch]);

  const handleExportBusinessesCSV = () => {
    if (!filteredBusinesses.length) {
      toast({
        title: "No businesses to export",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const headers = [
      "Business",
      "Coupon",
      "Contact Name",
      "Email",
      "Added By",
      "Created",
      "Status",
    ];
    const rows = filteredBusinesses.map((b) => [
      b.name?.en || "",
      b.offerTitle?.en || "",
      b.contactName || "",
      b.email || "",
      b.addedBy || "",
      b.createdAt?.toDate().toLocaleString() || "",
      getBusinessStatus(b).label,
    ]);

    const csv = [
      headers.map(escapeCsvField).join(","),
      ...rows.map((row) => row.map(escapeCsvField).join(",")),
    ].join("\r\n");

    const blob = new Blob(["﻿" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const safeName = (campaignName || "campaign").replace(/[^\w-]+/g, "_");
    const dateStr = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = `businesses-${safeName}-${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast({
      title: `Exported ${filteredBusinesses.length} business${
        filteredBusinesses.length === 1 ? "" : "es"
      }`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const filteredAgents = useMemo(() => {
    const q = agentSearch.trim().toLowerCase();
    if (!q) return agents;
    return agents.filter((a) => {
      const haystack = [
        getAgentDisplayName(a),
        a.email,
        a.isAdmin ? "Admin" : "Team Member",
        a.status === "pending" ? "Pending" : "Active",
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [agents, agentSearch]);

  const handleExportAgentsCSV = () => {
    if (!filteredAgents.length) {
      toast({
        title: "No team members to export",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const headers = [
      "Name",
      "Email",
      "Role",
      "Status",
      "Sales",
      "Sales Amount",
    ];
    const rows = filteredAgents.map((a) => [
      getAgentDisplayName(a),
      a.email || "",
      a.isAdmin ? "Admin" : "Team Member",
      a.status === "pending" ? "Pending" : "Active",
      a.saleCount || 0,
      `$${(a.saleAmount || 0).toFixed(2)}`,
    ]);

    const csv = [
      headers.map(escapeCsvField).join(","),
      ...rows.map((row) => row.map(escapeCsvField).join(",")),
    ].join("\r\n");

    const blob = new Blob(["﻿" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const safeName = (campaignName || "campaign").replace(/[^\w-]+/g, "_");
    const dateStr = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = `team-members-${safeName}-${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast({
      title: `Exported ${filteredAgents.length} team member${
        filteredAgents.length === 1 ? "" : "s"
      }`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const getSupporterDisplayName = (supporter) =>
    supporter?.name || supporter?.email || "Supporter";

  const getSupporterCoupons = (supporter) => {
    if (!supporter) return [];
    const businessIds = Array.isArray(supporter.businessIds)
      ? supporter.businessIds
      : [];
    const redemptions = supporter.redemptions || {};
    const businessById = new Map(businesses.map((b) => [b.id, b]));

    return businessIds
      .map((entry) => {
        const id = typeof entry === "string" ? entry : entry?.id;
        const business = businessById.get(id);
        if (!business || !business.approved) return null;
        const redemption = redemptions[id] || null;
        const redeemedAt = redemption?.date?.toDate
          ? redemption.date.toDate()
          : redemption?.date
            ? new Date(redemption.date)
            : null;
        return {
          id,
          businessName: business.name?.en || "",
          offerTitle: business.offerTitle?.en || "",
          redeemed: !!redemption,
          redeemedAt,
          notes: redemption?.notes || "",
        };
      })
      .filter(Boolean);
  };

  const filterAndSortCoupons = (coupons) => {
    const search = couponSearch.trim().toLowerCase();
    return coupons.filter((c) => {
      if (couponStatusFilter === "redeemed" && !c.redeemed) return false;
      if (couponStatusFilter === "unredeemed" && c.redeemed) return false;
      if (!search) return true;
      return (
        c.businessName.toLowerCase().includes(search) ||
        c.offerTitle.toLowerCase().includes(search)
      );
    });
  };

  const supporterCouponColumns = [
    {
      name: "Business",
      selector: (row) => row.businessName,
      sortable: true,
      grow: 2,
    },
    {
      name: "Offer",
      selector: (row) => row.offerTitle,
      sortable: true,
      grow: 2,
    },
    {
      name: "Status",
      selector: (row) => (row.redeemed ? "Redeemed" : "Unredeemed"),
      sortable: true,
      cell: (row) => (
        <Badge
          colorScheme={row.redeemed ? "green" : "gray"}
          variant="subtle"
        >
          {row.redeemed ? "Redeemed" : "Unredeemed"}
        </Badge>
      ),
      width: "140px",
    },
    {
      name: "Redeemed On",
      selector: (row) =>
        row.redeemedAt ? row.redeemedAt.getTime() : 0,
      sortable: true,
      cell: (row) =>
        row.redeemedAt ? row.redeemedAt.toLocaleString() : "—",
      grow: 2,
    },
  ];

  const copyToClipboard = (agentId) => {
    const url = `https://app.digitalcouponbook.ca/support/${campaignId}/${agentId}`;
    navigator.clipboard.writeText(url).then(() => {
      toast({
        title: "URL Copied",
        description: "The agent's URL has been copied to your clipboard.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    });
  };

  const copyNewCustomerUrl = () => {
    const url = `${window.location.origin}/support/${campaignId}`;
    navigator.clipboard.writeText(url).then(() => {
      toast({
        title: "URL Copied",
        description: "The new customer URL has been copied to your clipboard.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    });
  };

  const agentColumns = [
    {
      name: "Name",
      selector: (row) =>
        `${row.firstName || ""} ${row.lastName || ""}`.trim() ||
        row.email ||
        "",
      sortable: true,
      grow: 1,
      minWidth: "110px",
    },
    {
      name: "Role",
      selector: (row) => (row.isAdmin ? "Admin" : "Team Member"),
      cell: (row) => (
        <Badge
          colorScheme={row.isAdmin ? "purple" : "gray"}
          variant="subtle"
          textTransform="none"
          fontWeight="medium"
          borderRadius="full"
          px={3}
          py={0.5}
        >
          {row.isAdmin ? "Admin" : "Team Member"}
        </Badge>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Sales",
      selector: (row) => row.saleCount || 0,
      cell: (row) => {
        const count = row.saleCount || 0;
        return (
          <Box lineHeight="short">
            <Text fontSize="sm">
              {count} sale{count === 1 ? "" : "s"}
            </Text>
            <Text fontSize="xs" color="gray.500">
              ${(row.saleAmount || 0).toFixed(2)}
            </Text>
          </Box>
        );
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => (row.status === "pending" ? "Pending" : "Active"),
      cell: (row) => {
        const isPending = row.status === "pending";
        return (
          <Badge
            colorScheme={isPending ? "yellow" : "green"}
            variant="subtle"
            textTransform="none"
            fontWeight="medium"
            borderRadius="full"
            px={3}
            py={0.5}
          >
            {isPending ? "Pending" : "Active"}
          </Badge>
        );
      },
      sortable: true,
      width: agentStatusColumnWidth,
    },
    {
      cell: (row) => {
        const isPending = row.status === "pending";
        const isResending = !!loadingAgents[row.id];
        return (
          <HStack spacing={1} justify="flex-end">
            {isAdmin && !isPending && (
              <IconButton
                icon={<FaEdit />}
                aria-label="Edit team member"
                title="Edit"
                size="sm"
                variant="ghost"
                color="gray.500"
                _hover={{ color: "gray.700", bg: "gray.100" }}
                onClick={() => initiateEditAgent(row)}
              />
            )}
            <Menu placement="bottom-end">
              <MenuButton
                as={IconButton}
                icon={<FaEllipsisV />}
                variant="ghost"
                size="sm"
                aria-label="More actions"
                color="gray.500"
                _hover={{ color: "gray.700", bg: "gray.100" }}
                _active={{ bg: "gray.100" }}
              />
              <Portal>
                <MenuList shadow="lg" borderRadius="md" py={1} minW="200px">
                  <Tooltip
                    label={row.email || "No email on file"}
                    hasArrow
                    placement="left"
                    isDisabled={!row.email}
                    openDelay={200}
                  >
                    <MenuItem
                      icon={<FaEnvelope />}
                      as={row.email ? "a" : "button"}
                      href={row.email ? `mailto:${row.email}` : undefined}
                      isDisabled={!row.email}
                    >
                      Send email
                    </MenuItem>
                  </Tooltip>
                  {!isPending && (
                    <MenuItem
                      icon={<FaLink />}
                      onClick={() => copyToClipboard(row.id)}
                    >
                      Copy invite link
                    </MenuItem>
                  )}
                  {isAdmin && isPending && (
                    <MenuItem
                      icon={
                        isResending ? (
                          <Spinner size="sm" />
                        ) : (
                          <FaPaperPlane />
                        )
                      }
                      onClick={() => handleResendAgentInvitation(row)}
                      isDisabled={isResending}
                    >
                      Resend Invitation
                    </MenuItem>
                  )}
                  {isAdmin && (
                    <>
                      <MenuDivider />
                      <MenuItem
                        icon={<FaTrash />}
                        color="red.500"
                        onClick={() =>
                          isPending
                            ? deletePendingInvite(row)
                            : initiateRemoveAgent(row)
                        }
                      >
                        {isPending ? "Delete invitation" : "Remove"}
                      </MenuItem>
                    </>
                  )}
                </MenuList>
              </Portal>
            </Menu>
          </HStack>
        );
      },
      width: "80px",
      right: true,
    },
  ];

  const initiateRemoveAgent = (agent) => {
    setFundraiserToRemove(agent);
    setIsRemoveModalOpen(true);
  };

  const confirmRemoveAgent = async () => {
    if (!fundraiserToRemove) return;

    try {
      await axios.delete(
        `${apiUrl}/campaigns/${campaignId}/agents/${fundraiserToRemove.id}`,
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );

      // Update local state
      setAgents(agents.filter((agent) => agent.id !== fundraiserToRemove.id));
      setCampaignStats((prev) => ({
        ...prev,
        agentCount: prev.agentCount - 1,
      }));

      toast({
        title: "Success",
        description: "Team Member removed successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setIsRemoveModalOpen(false);
      setFundraiserToRemove(null);
    } catch (error) {
      console.error("Error removing fundraiser:", error);
      toast({
        title: "Error",
        description: "Failed to remove fundraiser. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddAgent = async (values, { setSubmitting, resetForm }) => {
    try {
      const idToken = sessionStorage.getItem("idToken");
      const response = await axios.post(
        `${apiUrl}/campaigns/${campaignId}/agents`,
        values,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );

      // If the response indicates a pending invite
      if (response.data.status === "pending") {
        // Add a temporary row to the agents list with pending status
        setAgents((prevAgents) => [
          ...prevAgents,
          {
            id: response.data.inviteId, // Use the invite ID as temporary ID
            email: values.email,
            firstName: "Pending",
            lastName: "Invitation",
            isAdmin: values.isAdmin,
            saleCount: 0,
            saleAmount: 0,
            status: "pending",
          },
        ]);
      } else {
        // Add the new agent to the list
        setAgents((prevAgents) => [...prevAgents, response.data.agent]);
      }

      setIsModalOpen(false);
      resetForm();
      toast({
        title:
          response.data.status === "pending"
            ? "Invitation Sent"
            : "Team Member Added",
        description:
          response.data.status === "pending"
            ? "An invitation has been sent to the email address"
            : "The team member has been added successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      // Update campaign stats
      setCampaignStats((prev) => ({
        ...prev,
        agentCount: prev.agentCount + 1,
      }));
    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to add team member",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleBackClick = () => {
    if (organizationId) {
      navigate(`/organization/${organizationId}`);
    }
  };

  const fundraisersStat = (
    <Stat bg="white" p={4} borderRadius="lg" boxShadow="md" position="relative">
      <Flex justifyContent="space-between" alignItems="flex-start">
        <StatLabel fontSize="lg">Team Members</StatLabel>
        <Icon as={FaUsers} boxSize={7} color="green.500" />
      </Flex>
      <Flex justifyContent="space-between" alignItems="flex-end" mt={4}>
        <StatNumber fontSize="3xl">{campaignStats.agentCount}</StatNumber>
        {isAdmin && (
          <IconButton
            size="sm"
            onClick={() => setIsModalOpen(true)}
            icon={<Icon as={FaPlus} />}
            aria-label="Add Team Member"
          />
        )}
      </Flex>
    </Stat>
  );

  const addAgentModal = (
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Team Member</ModalHeader>
        <ModalCloseButton />
        <Formik
          initialValues={{ email: "", isAdmin: false }}
          validationSchema={validationSchema}
          onSubmit={handleAddAgent}
        >
          {(props) => (
            <Form>
              <ModalBody>
                <VStack spacing={4}>
                  <Field name="email">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={form.errors.email && form.touched.email}
                        isRequired
                      >
                        <FormLabel>Email</FormLabel>
                        <Input
                          {...field}
                          placeholder="Enter team member's email"
                        />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="isAdmin">
                    {({ field }) => (
                      <FormControl>
                        <Checkbox {...field}>Make Admin</Checkbox>
                      </FormControl>
                    )}
                  </Field>
                </VStack>
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  isLoading={props.isSubmitting}
                >
                  Add Team Member
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );

  const handleSaveSocialShare = async () => {
    if (
      socialShareTitle.length > SOCIAL_TITLE_MAX ||
      socialShareBody.length > SOCIAL_BODY_MAX
    ) {
      toast({
        title: "Too long",
        description: "Please shorten the title or message before saving.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    setIsSavingSocialShare(true);
    try {
      await axios.put(
        `${apiUrl}/campaigns/${campaignId}`,
        {
          socialShareTitle: socialShareTitle.trim(),
          socialShareBody: socialShareBody.trim(),
        },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );
      toast({
        title: "Saved",
        description: "Social sharing content updated.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error saving social sharing content:", error);
      toast({
        title: "Save failed",
        description:
          error.response?.data?.message ||
          "Could not save social sharing content.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSavingSocialShare(false);
    }
  };

  const handleSaveTeamInstructions = async () => {
    setIsSavingTeamInstructions(true);
    try {
      const payload = isQuillEmpty(teamInstructions) ? "" : teamInstructions;
      await axios.put(
        `${apiUrl}/campaigns/${campaignId}`,
        { teamInstructions: payload },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );
      setSavedTeamInstructions(payload);
      setTeamUpdateNote("");
      setIsTeamUpdateModalOpen(true);
    } catch (error) {
      console.error("Error saving team instructions:", error);
      toast({
        title: "Save failed",
        description:
          error.response?.data?.message || "Could not save team instructions.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSavingTeamInstructions(false);
    }
  };

  const handleSendTeamUpdateEmail = async () => {
    if (isQuillEmpty(savedTeamInstructions)) {
      toast({
        title: "Nothing to send",
        description: "Add some content to the Team Update before emailing it.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    setIsSendingTeamUpdate(true);
    try {
      const res = await axios.post(
        `${apiUrl}/campaigns/${campaignId}/team-update/notify`,
        {
          note: teamUpdateNote,
          updateHtml: savedTeamInstructions,
        },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );
      const { sent = 0, failed = 0 } = res.data || {};
      toast({
        title: "Update sent",
        description:
          failed > 0
            ? `Sent to ${sent} team member${sent === 1 ? "" : "s"}, ${failed} failed.`
            : `Sent to ${sent} team member${sent === 1 ? "" : "s"}.`,
        status: failed > 0 ? "warning" : "success",
        duration: 4000,
        isClosable: true,
      });
      setIsTeamUpdateModalOpen(false);
    } catch (error) {
      console.error("Error sending team update email:", error);
      toast({
        title: "Send failed",
        description:
          error.response?.data?.error || "Could not send team update email.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSendingTeamUpdate(false);
    }
  };

  const handleEditAgent = async (values, actions) => {
    try {
      const response = await axios.put(
        `${apiUrl}/campaigns/${campaignId}/agents/${editingAgent.id}`,
        { isAdmin: values.isAdmin },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );

      // Update local state
      setAgents(
        agents.map((agent) =>
          agent.id === editingAgent.id
            ? { ...agent, isAdmin: values.isAdmin }
            : agent,
        ),
      );

      toast({
        title: "Success",
        description: "Team member updated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      actions.setSubmitting(false);
      setIsEditModalOpen(false);
    } catch (error) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "Failed to update team member",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      actions.setSubmitting(false);
    }
  };

  const initiateEditAgent = (agent) => {
    setEditingAgent(agent);
    setIsEditModalOpen(true);
  };

  const editAgentModal = (
    <Modal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Team Member</ModalHeader>
        <ModalCloseButton />
        <Formik
          initialValues={{ isAdmin: editingAgent?.isAdmin || false }}
          onSubmit={handleEditAgent}
        >
          {(props) => (
            <Form>
              <ModalBody>
                <VStack spacing={4} align="stretch">
                  <Text>
                    {editingAgent?.firstName} {editingAgent?.lastName}
                  </Text>
                  <Field name="isAdmin">
                    {({ field }) => (
                      <FormControl>
                        <Checkbox {...field} isChecked={field.value}>
                          Make Admin
                        </Checkbox>
                      </FormControl>
                    )}
                  </Field>
                </VStack>
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  isLoading={props.isSubmitting}
                >
                  Save Changes
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );

  const handleResendAgentInvitation = async (agent) => {
    setLoadingAgents((prev) => ({ ...prev, [agent.id]: true }));
    try {
      await axios.post(
        `${apiUrl}/pendingInvites/${agent.id}/resend`,
        {},
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );

      toast({
        title: "Success",
        description: "Invitation email resent to team member",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error resending invitation:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "Failed to resend invitation",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingAgents((prev) => ({ ...prev, [agent.id]: false }));
    }
  };

  const deletePendingInvite = async (agent) => {
    try {
      await axios.delete(`${apiUrl}/pendingInvites`, {
        headers: { Authorization: `Bearer ${idToken}` },
        data: {
          type: "campaign",
          id: campaignId,
          email: agent.email,
        },
      });

      // Update local state
      setAgents(agents.filter((a) => a.id !== agent.id));
      setCampaignStats((prev) => ({
        ...prev,
        agentCount: prev.agentCount - 1,
      }));

      toast({
        title: "Success",
        description: "Invitation deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error deleting invitation:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.message || "Failed to delete invitation",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const initiateDeleteBusiness = (business) => {
    setBusinessToDelete(business);
    setIsDeleteBusinessModalOpen(true);
  };

  const confirmDeleteBusiness = async () => {
    if (!businessToDelete) return;

    try {
      await axios.delete(`${apiUrl}/businesses/${businessToDelete.id}`, {
        headers: { Authorization: `Bearer ${idToken}` },
      });

      // Update local state
      setBusinesses(businesses.filter((b) => b.id !== businessToDelete.id));
      setCampaignStats((prev) => ({
        ...prev,
        businessCount: prev.businessCount - 1,
      }));

      toast({
        title: "Success",
        description: "Business deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setIsDeleteBusinessModalOpen(false);
      setBusinessToDelete(null);
    } catch (error) {
      console.error("Error deleting business:", error);
      toast({
        title: "Error",
        description: "Failed to delete business. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSendForApproval = async (business) => {
    setLoadingBusinesses((prev) => ({ ...prev, [business.id]: true }));
    try {
      const idToken = sessionStorage.getItem("idToken");
      await axios.post(
        `${apiUrl}/generate-business-link`,
        {
          email: business.email,
          businessId: business.id,
          type: "approval",
          campaignId: campaignId,
        },
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );

      toast({
        title: "Success",
        description: "Approval request sent to business",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error sending approval request:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "Failed to send approval request",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingBusinesses((prev) => ({ ...prev, [business.id]: false }));
    }
  };

  const handleResendInvitation = async (business) => {
    setLoadingBusinesses((prev) => ({ ...prev, [business.id]: true }));
    try {
      const idToken = sessionStorage.getItem("idToken");
      await axios.post(
        `${apiUrl}/generate-business-link`,
        {
          email: business.email,
          businessId: business.id,
          type: "resend-invite",
          campaignId: campaignId,
        },
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );

      toast({
        title: "Success",
        description: "Invitation email resent to business",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error resending invitation:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "Failed to resend invitation",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingBusinesses((prev) => ({ ...prev, [business.id]: false }));
    }
  };

  const handleSendOwnerClaim = async (business) => {
    setLoadingBusinesses((prev) => ({ ...prev, [business.id]: true }));
    try {
      const idToken = sessionStorage.getItem("idToken");
      await axios.post(
        `${apiUrl}/send-owner-claim-link`,
        { businessId: business.id },
        { headers: { Authorization: `Bearer ${idToken}` } },
      );
      toast({
        title: "Invitation sent",
        description: `Account-setup email sent to ${business.email}`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error sending owner claim link:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error ||
          "Failed to send account-setup email",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoadingBusinesses((prev) => ({ ...prev, [business.id]: false }));
    }
  };

  const handleResendEmail = async (customerId) => {
    setLoadingCustomers((prev) => ({ ...prev, [customerId]: true }));
    try {
      await axios.post(
        `${apiUrl}/send-customer-purchase-email`,
        { customerId },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        },
      );

      toast({
        title: "Success",
        description: "Purchase email resent successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error resending email:", error);
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to resend email",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingCustomers((prev) => ({ ...prev, [customerId]: false }));
    }
  };

  if (!roleChecked) {
    return (
      <>
        {!embedded && <Navbar />}
        <Flex
          minH={embedded ? "40vh" : "calc(100vh - 60px)"}
          justify="center"
          align="center"
          width="100%"
        >
          <Spinner size="xl" />
        </Flex>
      </>
    );
  }

  if (isTeamMember) {
    return (
      <>
        {!embedded && <Navbar />}
        <Box
          minH={embedded ? undefined : "calc(100vh - 60px)"}
          bg={embedded ? undefined : "primaryBackground"}
          pt={embedded ? 0 : "30px"}
          width="100%"
        >
          <TeamMemberDashboard
            campaignId={campaignId}
            agentId={user?.uid}
            embedded={embedded}
          />
        </Box>
      </>
    );
  }

  return (
    <>
      {!embedded && <Navbar />}
      <Box
        minH={embedded ? undefined : "calc(100vh - 60px)"}
        bg={embedded ? undefined : "primaryBackground"}
        pt={embedded ? 0 : "30px"}
        px={embedded ? 0 : 4}
        width="100%"
      >
        <VStack
          align="stretch"
          maxWidth={embedded ? undefined : "1200px"}
          margin={embedded ? undefined : "0 auto"}
          // pt={8}
          spacing={8}
          width="100%"
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            justify={
              embedded
                ? { base: "center", md: "flex-end" }
                : { base: "center", md: "space-between" }
            }
            align={{ base: "center", md: "flex-start" }}
            gap={4}
          >
            {!embedded && (
              <Box textAlign={{ base: "center", md: "left" }}>
                <Heading as="h1" size="lg" color="heading">
                  Campaign Dashboard
                </Heading>
                <Text color="text" fontSize="xl">
                  {campaignName}
                </Text>
              </Box>
            )}
            <VStack
              spacing={4}
              align={{ base: "center", sm: "flex-end" }}
              width={{ base: "100%", sm: "auto" }}
            >
              <Flex
                direction={{ base: "column", sm: "row" }}
                gap={2}
                width="100%"
              >
                <HStack spacing={2} justify={{ base: "center", sm: "flex-start" }}>
                  <Tooltip label="Copy Purchase URL" hasArrow placement="top">
                    <IconButton
                      icon={<FaLink />}
                      aria-label="Copy Purchase URL"
                      onClick={copyNewCustomerUrl}
                      size={buttonSize}
                      variant="outline"
                    />
                  </Tooltip>
                  <Tooltip label="Show Purchase URL QR Code" hasArrow placement="top">
                    <IconButton
                      icon={<FaQrcode />}
                      aria-label="Show Purchase URL QR Code"
                      onClick={() => setIsPurchaseQRModalOpen(true)}
                      size={buttonSize}
                      variant="outline"
                    />
                  </Tooltip>
                </HStack>
                {isAdmin && (
                  <Button
                    onClick={() => navigate(`/edit-campaign/${campaignId}`)}
                    size={buttonSize}
                    variant="secondary"
                    width={{ base: "full", sm: "auto" }}
                  >
                    Edit Campaign
                  </Button>
                )}
              </Flex>
            </VStack>
          </Flex>

          <SimpleGrid
            columns={{ base: 1, sm: 2, lg: 4 }}
            spacing={6}
            width="100%"
          >
            <Stat
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
            >
              <Flex justifyContent="space-between" alignItems="flex-start">
                <StatLabel fontSize="lg">Total Amount Sold</StatLabel>
                <Icon as={FaDollarSign} boxSize={7} color="green.500" />
              </Flex>
              <Flex justifyContent="space-between" alignItems="flex-end" mt={4}>
                <StatNumber fontSize="3xl">
                  ${campaignStats.totalAmountSold.toFixed(2)}
                </StatNumber>
              </Flex>
            </Stat>
            <Stat
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
            >
              <Flex justifyContent="space-between" alignItems="flex-start">
                <StatLabel fontSize="lg">Supporters</StatLabel>
                <Icon as={FaHandshake} boxSize={7} color="green.500" />
              </Flex>
              <Flex justifyContent="space-between" alignItems="flex-end" mt={4}>
                <StatNumber fontSize="3xl">
                  {campaignStats.totalSalesCount}
                </StatNumber>
              </Flex>
            </Stat>
            <Stat
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
            >
              <Flex justifyContent="space-between" alignItems="flex-start">
                <StatLabel fontSize="lg">Coupons</StatLabel>
                <Icon as={FaTicketAlt} boxSize={7} color="green.500" />
              </Flex>
              <Flex justifyContent="space-between" alignItems="flex-end" mt={4}>
                <StatNumber fontSize="3xl">
                  {campaignStats.businessCount}
                </StatNumber>
                <IconButton
                  size="sm"
                  onClick={() =>
                    navigate(`/business-type-selection/${campaignId}`)
                  }
                  icon={<Icon as={FaPlus} />}
                  aria-label="Add Business"
                />
              </Flex>
            </Stat>
            <Stat
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
            >
              <Flex justifyContent="space-between" alignItems="flex-start">
                <StatLabel fontSize="lg">Team Members</StatLabel>
                <Icon as={FaUsers} boxSize={7} color="green.500" />
              </Flex>
              <Flex justifyContent="space-between" alignItems="flex-end" mt={4}>
                <StatNumber fontSize="3xl">
                  {campaignStats.agentCount}
                </StatNumber>
                {isAdmin && (
                  <IconButton
                    size="sm"
                    onClick={() => setIsModalOpen(true)}
                    icon={<Icon as={FaPlus} />}
                    aria-label="Add Team Member"
                  />
                )}
              </Flex>
            </Stat>
          </SimpleGrid>

          <Box
            width="100%"
            bg="secondaryBackground"
            p={{ base: 4, md: 10 }}
            borderRadius="xl"
            boxShadow="md"
          >
            <VStack spacing={6} align="stretch">
              <Tabs variant="brand" index={tabIndex} onChange={setTabIndex}>
                <TabList>
                  <Tab>Coupons</Tab>
                  <Tab>Team</Tab>
                  <Tab>Supporters</Tab>
                  <Tab>Reporting</Tab>
                  <Tab>Redemptions</Tab>
                  <Tab>Social Sharing</Tab>
                  <Tab>Templates</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel px={0}>
                    <Flex
                      mb={3}
                      gap={3}
                      align="center"
                      direction={{ base: "column", md: "row" }}
                    >
                      <InputGroup size="sm" maxW={{ base: "100%", md: "320px" }}>
                        <InputLeftElement pointerEvents="none">
                          <Icon as={FaSearch} color="gray.400" />
                        </InputLeftElement>
                        <Input
                          placeholder="Filter businesses"
                          value={businessSearch}
                          onChange={(e) => setBusinessSearch(e.target.value)}
                        />
                      </InputGroup>
                      <Button
                        size="sm"
                        variant="outline"
                        leftIcon={<Icon as={FaDownload} />}
                        onClick={handleExportBusinessesCSV}
                        isDisabled={!filteredBusinesses.length}
                        ml={{ base: 0, md: "auto" }}
                      >
                        Export to CSV
                      </Button>
                    </Flex>
                    <Box overflowX="auto">
                      <DataTable
                        columns={businessColumns}
                        data={filteredBusinesses}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30]}
                        highlightOnHover
                        striped
                        responsive
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel px={0}>
                    <Box
                      mb={6}
                      p={{ base: 4, md: 5 }}
                      borderWidth="1px"
                      borderColor="gray.200"
                      borderRadius="md"
                      bg="white"
                    >
                      <Heading as="h3" size="sm" mb={1}>
                        Team Update
                      </Heading>
                      <Text fontSize="sm" color="gray.600" mb={3}>
                        Post an update for your team. It appears on their
                        dashboard, and you can optionally email it to them too.
                      </Text>
                      <Box
                        sx={{
                          ".ql-toolbar": {
                            borderTopRadius: "md",
                            borderColor: "gray.200",
                          },
                          ".ql-container": {
                            borderBottomRadius: "md",
                            borderColor: "gray.200",
                            minHeight: "140px",
                            fontFamily: "inherit",
                            fontSize: "md",
                          },
                          ".ql-editor": { minHeight: "140px" },
                        }}
                      >
                        <ReactQuill
                          theme="snow"
                          value={teamInstructions}
                          onChange={setTeamInstructions}
                          modules={TEAM_INSTRUCTIONS_QUILL_MODULES}
                          formats={TEAM_INSTRUCTIONS_QUILL_FORMATS}
                          placeholder="e.g. Welcome! Here's our weekly goal..."
                        />
                      </Box>
                      <Box mt={3}>
                        <Button
                          variant="secondary"
                          onClick={handleSaveTeamInstructions}
                          isLoading={isSavingTeamInstructions}
                        >
                          Save
                        </Button>
                      </Box>
                    </Box>
                    <Flex
                      mb={3}
                      gap={3}
                      align="center"
                      direction={{ base: "column", md: "row" }}
                    >
                      <InputGroup size="sm" maxW={{ base: "100%", md: "320px" }}>
                        <InputLeftElement pointerEvents="none">
                          <Icon as={FaSearch} color="gray.400" />
                        </InputLeftElement>
                        <Input
                          placeholder="Filter team members"
                          value={agentSearch}
                          onChange={(e) => setAgentSearch(e.target.value)}
                        />
                      </InputGroup>
                      <Button
                        size="sm"
                        variant="outline"
                        leftIcon={<Icon as={FaDownload} />}
                        onClick={handleExportAgentsCSV}
                        isDisabled={!filteredAgents.length}
                        ml={{ base: 0, md: "auto" }}
                      >
                        Export to CSV
                      </Button>
                    </Flex>
                    <Box overflowX="auto">
                      <DataTable
                        columns={agentColumns}
                        data={filteredAgents}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30]}
                        highlightOnHover
                        striped
                        responsive
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel px={0}>
                    <Flex
                      mb={3}
                      gap={3}
                      align="center"
                      direction={{ base: "column", md: "row" }}
                    >
                      <InputGroup size="sm" maxW={{ base: "100%", md: "320px" }}>
                        <InputLeftElement pointerEvents="none">
                          <Icon as={FaSearch} color="gray.400" />
                        </InputLeftElement>
                        <Input
                          placeholder="Filter supporters"
                          value={customerSearch}
                          onChange={(e) => setCustomerSearch(e.target.value)}
                        />
                      </InputGroup>
                      <Button
                        size="sm"
                        variant="outline"
                        leftIcon={<Icon as={FaDownload} />}
                        onClick={handleExportSupportersCSV}
                        isDisabled={!filteredCustomers.length}
                        ml={{ base: 0, md: "auto" }}
                      >
                        Export to CSV
                      </Button>
                    </Flex>
                    <Box overflowX="auto">
                      <DataTable
                        columns={customerColumns}
                        data={filteredCustomers}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30]}
                        highlightOnHover
                        striped
                        responsive
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel px={0}>
                    <CampaignReporting campaignId={campaignId} />
                  </TabPanel>
                  <TabPanel px={0}>
                    <Flex
                      mb={3}
                      gap={3}
                      align="center"
                      direction={{ base: "column", md: "row" }}
                    >
                      <InputGroup size="sm" maxW={{ base: "100%", md: "320px" }}>
                        <InputLeftElement pointerEvents="none">
                          <Icon as={FaSearch} color="gray.400" />
                        </InputLeftElement>
                        <Input
                          placeholder="Filter businesses"
                          value={redemptionSearch}
                          onChange={(e) => setRedemptionSearch(e.target.value)}
                        />
                      </InputGroup>
                      <Button
                        size="sm"
                        variant="outline"
                        leftIcon={<Icon as={FaDownload} />}
                        onClick={handleExportRedemptionsCSV}
                        isDisabled={!filteredRedemptions.length}
                        ml={{ base: 0, md: "auto" }}
                      >
                        Export to CSV
                      </Button>
                    </Flex>
                    <Box overflowX="auto">
                      <DataTable
                        columns={redemptionColumns}
                        data={filteredRedemptions}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30]}
                        highlightOnHover
                        striped
                        responsive
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel px={0}>
                    <VStack spacing={5} align="stretch" maxW="640px">
                      <Text fontSize="sm" color="gray.600">
                        Customize the title and message used when this campaign
                        is shared on social media.
                      </Text>
                      <FormControl
                        isInvalid={socialShareTitle.length > SOCIAL_TITLE_MAX}
                      >
                        <FormLabel>Title</FormLabel>
                        <Input
                          value={socialShareTitle}
                          onChange={(e) => setSocialShareTitle(e.target.value)}
                          placeholder="Catchy share title"
                          maxLength={SOCIAL_TITLE_MAX}
                        />
                        <FormHelperText
                          color={
                            socialShareTitle.length > SOCIAL_TITLE_MAX
                              ? "red.500"
                              : "gray.500"
                          }
                        >
                          {socialShareTitle.length}/{SOCIAL_TITLE_MAX}{" "}
                          characters
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        isInvalid={socialShareBody.length > SOCIAL_BODY_MAX}
                      >
                        <FormLabel>Message</FormLabel>
                        <Textarea
                          value={socialShareBody}
                          onChange={(e) => setSocialShareBody(e.target.value)}
                          placeholder="The message that appears alongside the link"
                          rows={5}
                          maxLength={SOCIAL_BODY_MAX}
                        />
                        <FormHelperText
                          color={
                            socialShareBody.length > SOCIAL_BODY_MAX
                              ? "red.500"
                              : "gray.500"
                          }
                        >
                          {socialShareBody.length}/{SOCIAL_BODY_MAX} characters
                        </FormHelperText>
                      </FormControl>
                      <Box>
                        <Button
                          variant="secondary"
                          onClick={handleSaveSocialShare}
                          isLoading={isSavingSocialShare}
                        >
                          Save
                        </Button>
                      </Box>
                    </VStack>
                  </TabPanel>

                  <TabPanel px={0}>
                    <TemplatesLibrary />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </VStack>
          </Box>
          {!embedded && (
            <Box display="flex" justifyContent="flex-start" mb={8}>
              {organizationId && (
                <Button
                  leftIcon={<ArrowBackIcon />}
                  variant="ghost"
                  onClick={handleBackClick}
                  size="sm"
                >
                  Back to Organization
                </Button>
              )}
            </Box>
          )}
        </VStack>
      </Box>
      {addAgentModal}
      {editAgentModal}

      <Modal
        isOpen={isRemoveModalOpen}
        onClose={() => setIsRemoveModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Remove Team Member</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to remove {fundraiserToRemove?.name} from this
            campaign? This action cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              mr={3}
              onClick={() => setIsRemoveModalOpen(false)}
            >
              Cancel
            </Button>
            <Button colorScheme="red" onClick={confirmRemoveAgent}>
              Remove
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isErrorModalOpen}
        onClose={() => setIsErrorModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Error</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{errorMessage}</ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              onClick={() => setIsErrorModalOpen(false)}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isQRModalOpen}
        onClose={() => setIsQRModalOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Customer Code QR
            {qrSupporter?.name ? ` — ${qrSupporter.name}` : ""}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} py={2}>
              {qrSupporter?.customerCode ? (
                <>
                  <Box
                    bg="white"
                    p={4}
                    borderRadius="md"
                    borderWidth="1px"
                    borderColor="gray.200"
                  >
                    <QRCode
                      value={String(qrSupporter.customerCode)}
                      size={256}
                      level="M"
                    />
                  </Box>
                  <Text fontFamily="mono" fontSize="lg">
                    {qrSupporter.customerCode}
                  </Text>
                </>
              ) : (
                <Text color="gray.600">
                  No customer code on file for this supporter.
                </Text>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsQRModalOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isBusinessQRModalOpen}
        onClose={() => setIsBusinessQRModalOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Redemption QR Code
            {qrBusiness?.name?.en ? ` — ${qrBusiness.name.en}` : ""}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} py={2}>
              {qrBusiness?.id ? (
                <>
                  <Box
                    bg="white"
                    p={4}
                    borderRadius="md"
                    borderWidth="1px"
                    borderColor="gray.200"
                  >
                    <QRCode
                      value={getBusinessValidationUrl(qrBusiness)}
                      size={256}
                      level="H"
                    />
                  </Box>
                  <Tooltip
                    label={getBusinessValidationUrl(qrBusiness)}
                    hasArrow
                    placement="top"
                    openDelay={200}
                  >
                    <IconButton
                      icon={<FaCopy />}
                      aria-label="Copy redemption URL"
                      size="sm"
                      variant="ghost"
                      onClick={async () => {
                        const url = getBusinessValidationUrl(qrBusiness);
                        try {
                          await navigator.clipboard.writeText(url);
                          toast({
                            title: "URL copied to clipboard",
                            status: "success",
                            duration: 2000,
                            isClosable: true,
                          });
                        } catch (err) {
                          toast({
                            title: "Failed to copy URL",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                          });
                        }
                      }}
                    />
                  </Tooltip>
                </>
              ) : (
                <Text color="gray.600">
                  No redemption code on file for this business.
                </Text>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsBusinessQRModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isPurchaseQRModalOpen}
        onClose={() => setIsPurchaseQRModalOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Purchase URL QR Code</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} py={2}>
              <Box
                bg="white"
                p={4}
                borderRadius="md"
                borderWidth="1px"
                borderColor="gray.200"
              >
                <QRCode
                  value={`${window.location.origin}/support/${campaignId}`}
                  size={256}
                  level="M"
                />
              </Box>
              <Text fontSize="sm" color="gray.600" textAlign="center">
                Scan this code with your phone to open the purchase page.
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsPurchaseQRModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isCouponsModalOpen}
        onClose={() => setIsCouponsModalOpen(false)}
        size="3xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Coupons for {getSupporterDisplayName(selectedSupporter)}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {(() => {
              const coupons = getSupporterCoupons(selectedSupporter);
              const filtered = filterAndSortCoupons(coupons);
              const redeemedCount = coupons.filter((c) => c.redeemed).length;
              return (
                <VStack align="stretch" spacing={4}>
                  <Text color="gray.600" fontSize="sm">
                    {redeemedCount} of {coupons.length} coupons redeemed
                  </Text>
                  <Stack
                    direction={{ base: "column", md: "row" }}
                    spacing={3}
                  >
                    <InputGroup size="sm" flex={1}>
                      <InputLeftElement pointerEvents="none">
                        <Icon as={FaSearch} color="gray.400" />
                      </InputLeftElement>
                      <Input
                        placeholder="Search by business or offer"
                        value={couponSearch}
                        onChange={(e) => setCouponSearch(e.target.value)}
                      />
                    </InputGroup>
                    <Select
                      size="sm"
                      maxW={{ base: "100%", md: "220px" }}
                      value={couponStatusFilter}
                      onChange={(e) => setCouponStatusFilter(e.target.value)}
                    >
                      <option value="all">All statuses</option>
                      <option value="redeemed">Redeemed</option>
                      <option value="unredeemed">Unredeemed</option>
                    </Select>
                  </Stack>
                  <Box overflowX="auto">
                    <DataTable
                      columns={supporterCouponColumns}
                      data={filtered}
                      pagination
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[10, 20, 50]}
                      highlightOnHover
                      striped
                      responsive
                      defaultSortFieldId={1}
                      noDataComponent={
                        <Box py={6}>
                          <Text color="gray.500">
                            {coupons.length === 0
                              ? "This supporter has no coupons."
                              : "No coupons match the current filters."}
                          </Text>
                        </Box>
                      }
                    />
                  </Box>
                </VStack>
              );
            })()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsCouponsModalOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isDeleteBusinessModalOpen}
        onClose={() => setIsDeleteBusinessModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Business</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete {businessToDelete?.name?.en}? This
            action cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              mr={3}
              onClick={() => setIsDeleteBusinessModalOpen(false)}
            >
              Cancel
            </Button>
            <Button colorScheme="red" onClick={confirmDeleteBusiness}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isTeamUpdateModalOpen}
        onClose={() => setIsTeamUpdateModalOpen(false)}
        isCentered
        closeOnOverlayClick={!isSendingTeamUpdate}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Team Update saved</ModalHeader>
          <ModalCloseButton isDisabled={isSendingTeamUpdate} />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              <Text fontSize="sm" color="gray.700">
                Your Team Update is live on the team dashboard. Want to email
                it to your team too? You can add an optional short note that
                will appear above the update in the email.
              </Text>
              <FormControl>
                <FormLabel fontSize="sm">Optional note</FormLabel>
                <Textarea
                  value={teamUpdateNote}
                  onChange={(e) => setTeamUpdateNote(e.target.value)}
                  placeholder="e.g. Quick heads-up about this week's push..."
                  rows={4}
                  maxLength={500}
                />
                <FormHelperText>
                  {teamUpdateNote.length}/500 characters
                </FormHelperText>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              mr={3}
              onClick={() => setIsTeamUpdateModalOpen(false)}
              isDisabled={isSendingTeamUpdate}
            >
              Close
            </Button>
            <Button
              colorScheme="blue"
              leftIcon={<Icon as={FaEnvelope} />}
              onClick={handleSendTeamUpdateEmail}
              isLoading={isSendingTeamUpdate}
              loadingText="Sending"
            >
              Send Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CampaignHome;
